import messages from '@intlify/unplugin-vue-i18n/messages'
import { createI18n } from 'vue-i18n'

import { definePlugin } from '/@/app'

/**
 * messages are generated using vite-plugin-i18n
 * each .json files located in the ./src/locales are registered in messages
 * @see https://github.com/intlify/bundle-tools/tree/main/packages/vite-plugin-vue-i18n
 */

let plugin: any

export default definePlugin(({ app }) => {
  // This holds the language for the frontend side of the page.
  // It does not affect API requests. When translating the frontend to Turkish,
  // the field in account.ts should be removed and managed together with this.
  const defaultLocale = useStorage('locale', 'en')

  const i18n = createI18n({
    locale: defaultLocale.value,
    messages,
    sync: true,
    silentTranslationWarn: true, // true - warning off
    missingWarn: false,
    fallbackWarn: false,
    silentFallbackWarn: true,
  })

  plugin = i18n
  app.use(i18n)
})

export const useI18nWithout = (key: string, ...args: any[]) =>
  plugin.global.t(key, ...args)
